import PropTypes from "prop-types";
import styled from "styled-components";

export const ROW_HEIGHT = 56;

const Tr = styled.tr`
  border-bottom: ${props => `1px solid ${props.theme.colors.silverAlt}`};
  box-shadow: inset 0 -1px 0 0 #ededed;
  height: ${ROW_HEIGHT}px;

  &:last-child {
    border-bottom: none;
  }
  &:nth-of-type(even) {
    background-color: ${props => props.theme.colors.zebraStripe};
  }
`;

const Td = styled.td`
  padding: ${props => (props.nopadding ? 0 : "9px 10px")};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;
Td.propTypes = {
  extended: PropTypes.bool,
  nopadding: PropTypes.bool
};

const ActionCell = styled(Td)`
  text-align: center;
`;

const _BaseHeaderCell = styled.th`
  border-right: ${props => `1px solid ${props.theme.colors.makoLight}`};
  color: ${props => props.theme.colors.white};
  font-weight: 500;
  height: 48px;
  padding: 9px 15px 9px 8px;
`;

const ActionHeaderCell = styled(_BaseHeaderCell)`
  background: ${props => props.theme.colors.makoAlt};
  letter-spacing: 1.5px;
  text-transform: uppercase;
`;

const Th = styled(_BaseHeaderCell)`
  background: ${props => props.theme.colors.mako};
  cursor: ${props => (props.clickable ? "pointer" : "initial")};
  position: relative;

  /* Arrow Up */
  &::before {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: ${p => `5px solid ${p.theme.colors.white}`};
    content: "";
    display: ${p => (p.sort === "asc" ? "initial" : "none")};
    height: 0;
    position: absolute;
    top: 50%;
    transform: translateY(-6px);
    right: 5px;
    width: 0;
  }
  /* Arrow Down */
  &::after {
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: ${p => `5px solid ${p.theme.colors.white}`};
    content: "";
    display: ${p => (p.sort === "desc" ? "initial" : "none")};
    height: 0;
    position: absolute;
    top: 50%;
    transform: translateY(2px);
    right: 5px;
    width: 0;
  }
`;
Th.propTypes = {
  clickable: PropTypes.bool,
  sort: PropTypes.string
};
Th.defaultProps = {
  clickable: false,
  sort: null
};

const Tbody = styled.tbody``;
const Thead = styled.thead`
  & tr {
    height: 48px;
  }
`;

const Footer = styled.div`
  border: 1px solid #eee;
  text-align: left;
  height: ${ROW_HEIGHT}px;
  background-color: #fff;
  bottom: 0px;
  width: 100%;
`;

const Table = styled.table`
  background-color: white;
  border-spacing: 0;
  position: relative;
  width: 100%;
`;

Table.Tr = Tr;
Table.Row = Tr;
Table.Td = Td;
Table.Cell = Td;
Table.ActionCell = ActionCell;
Table.HeaderCell = Th;
Table.Th = Th;
Table.ActionHeaderCell = ActionHeaderCell;
Table.Header = Thead;
Table.Thead = Thead;
Table.Body = Tbody;
Table.Tbody = Tbody;
Table.Footer = Footer;

export default Table;
